export interface StateInterface {
  loginBackground: boolean;
  branded: boolean;
  applicationName: string;
}

const state: StateInterface = {
  loginBackground: false,
  branded: false,
  applicationName: ""
};

export default state;
